// @flow

import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { AtlassianLogo } from '@atlaskit/logo';
import { B200, B400, N20 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';

export const Section = styled.section`
  width: 360px;
  margin: 200px auto;
`;

export const LogoContainer = styled.div`
  width: 248px;
  height: 133px;
  background: ${N20};
  margin: 0 auto 31px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Logo = () => (
  <LogoContainer>
    <AtlassianLogo
      textColor={B400}
      iconColor={B200}
      iconGradientStart={B400}
      iconGradientStop={B200}
    />
  </LogoContainer>
);

const AtlassianSupportsUkraineRoute = () => (
  <Section>
    <EmptyState
      header="Atlassian stands with Ukraine"
      description="We have paused the sale of all new software to customers from Russia and Belarus. Partners from these regions will not be able to create new apps."
      primaryAction={
        <Button
          appearance="link"
          href="https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine"
        >
          Learn more
        </Button>
      }
      renderImage={() => <Logo />}
    />
  </Section>
);

export default AtlassianSupportsUkraineRoute;
